import { inject, Injectable } from '@angular/core';

import { useFirmwareStore } from '../../../+state/firmware-package/firmware-api.store';



@Injectable({ providedIn: 'root'})
export class ReleaseNotesService {
     private store = inject(useFirmwareStore);

  async getSupportedLanguages() {
    await this.store.loadAllLanguages();
    return this.store.allLangauges.data?.();
  }
}